import * as React from "react";
import "./style.less";
export class SPPageLoader extends React.Component<{}, {}> {

    render() {
        return <div className="sp-page-default sp-page sp-page-light sp-page-navbar">
            <div className="sp-navbar"></div>
            <div id="home" className="sp-details">
                <div className="sp-event-info">
                    <div className="sp-event-info-img">

                    </div>
                    <div className="sp-event-info-desc">
                        <div className="sp-container">
                            <div className="sp-embed-info">
                                <div className="sp-embed-info-date text">
                                </div>
                                <div className="sp-embed-info-other">
                                    <h3 className="sp-embed-eventname text"></h3>
                                    <div className="sp-embed-info-time text">
                                        <span>&nbsp;</span>
                                    </div>
                                    <div className="sp-embed-info-addr text">
                                        <span>&nbsp;</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sp-event-desc">
                    <div className="sp-container">
                        <div className="sp-event-desc-container">
                            <div className="sp-event-desc-content">
                                <p className="text">&nbsp;</p>
                                <p className="text">&nbsp;</p>
                                <p className="text">&nbsp;</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="sp-part sp-tickets">
                <div className="sp-container">
                    <div className="sp-embed">
                        <div className="sp-embed-container">
                            <div className="sp-embed-tickets">
                                <div className="sp-embed-tickets-list">
                                    <div className="sp-embed-tickets-item"></div>
                                    <div className="sp-embed-tickets-item"></div>
                                    <div className="sp-embed-tickets-item"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

}


// WEBPACK FOOTER //
// ./src/Apps/ticketing/components/Desktop/Loader/EmptyView.tsx